/**
 * Route for `drill-down-analytics`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DrillDownAnalyticsPage } from "../features/drill-down-analytics/DrillDownAnalyticsPage";

export const drillDownAnalyticsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/drill-down-analytics",
	component: DrillDownAnalyticsPage,
});

export default drillDownAnalyticsRoute;
